import React, { useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Routes from './routes';
import ModalController from './components/modal';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Authentication from './components/authentication';
import config from './config';
import { ESystemName } from './types/enum';

const App = () => {
  useEffect(() => {
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    if (config.systemName === ESystemName.HOIAN) {
      link.href = '/logo_hoian.png';
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Authentication />
      <Routes />
      <ModalController />
    </LocalizationProvider>
  );
};

export default App;
